








































































import BaseComponent from '@/core/base.component';
import { Component, Vue } from 'vue-property-decorator';
import { CompanyDto } from '@/dto/company/company.dto';
import companyService from '@/services/company.service';
import CardWithTitle from '@/modules/_common/components/CardWithTitle.vue';
import CompanyChangeDialog from '@/modules/company/components/CompanyChangeDialog.vue';
import store from '@/store';

import { getColor } from '@/modules/_common/utils/getColor';

@Component({
  name: 'CompanyDetail',
  components: { CardWithTitle, CompanyChangeDialog },
})
export default class CompanyDetail extends BaseComponent {
  private companyDto = new CompanyDto();
  private infoChangeDialog = false;
  private detailLoading = false;

  get myRole() {
    return store.state.myRole;
  }

  getColor(status) {
    return getColor(status);
  }

  getCompany() {
    this.detailLoading = true;
    companyService.findOne().subscribe(res => {
      this.companyDto = res.data;
      this.detailLoading = false;
    });
  }
  mounted() {
    this.getCompany();
  }
  activated() {
    this.getCompany();
  }
}
